export const SDK_DOC_VERSIONS = ['3.0.0', '3.0.2', '4.0.1', '4.0.2'] as const;
export type SdkDocVersion = (typeof SDK_DOC_VERSIONS)[number];

export function packageDocsUrl(version: string) {
  return `/package-docs-local/${version}`;
}

export function isSdkDocVersion(version: string): version is SdkDocVersion {
  return (SDK_DOC_VERSIONS as readonly string[]).includes(version);
}
